<template>
  <div class="components-dialog">
    <a-modal
      :title="form.id ? (form.disabled ? '查看' : $t('update')) : $t('create')"
      :visible="dialog"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="footer">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          提交
        </a-button>
      </template>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="参数名称" prop="paramName">
          <a-input
            :disabled="form.disabled"
            v-model="form.paramName"
            placeholder="请输入参数名称"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="参数键名" prop="paramKey">
          <a-input
            :disabled="form.disabled"
            v-model="form.paramKey"
            placeholder="请输入参数键名"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="参数键值" prop="paramValue">
          <a-input
            :disabled="form.disabled"
            v-model="form.paramValue"
            placeholder="请输入参数键值"
            :maxLength="maxLength"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { ParamServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const api = new ParamServiceProxy();
const options = {
  submit: api.submit.bind(api),
};
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
  },
  data() {
    return {
      rules: {
        paramName: [
          { required: true, message: "参数名称必填", trigger: "blur" },
        ],
        paramKey: [
          { required: true, message: "参数键名必填", trigger: "blur" },
        ],
        paramValue: [
          { required: true, message: "参数键值必填", trigger: "blur" },
        ],
      },
      ...options,
      maxLength: 30,
      loading: false,
    };
  },
  methods: {
    cancel() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    confirm() {
      if (this.loading) {
        return;
      }
      if (this.form.disabled) {
        return this.$emit("close");
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.submit(this.form).then((res) => {
            this.$emit("update");
            this.loading = false;
          }).catch(_=>{
            this.loading = true;
          });
        }
      });
    },
  },
};
</script>